import { CMButton } from "@chartmetric/chartmetric-design-system/components/CMButton";
import { faMoon } from "@fortawesome/pro-solid-svg-icons/faMoon";
import { faSun } from "@fortawesome/pro-solid-svg-icons/faSun";

import { useTheme } from "../contexts/ThemeContext";

function DarkModeToggle() {
  const { theme, toggleTheme } = useTheme();
  return (
    <CMButton
      type="button"
      iconLeft={theme === "dark" ? faSun : faMoon}
      variant="secondaryText"
      size="sm"
      onClick={toggleTheme}
    />
  );
}

export default DarkModeToggle;
